module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"reservationDialog.reservationsNotFound":"There is no reference to this reservation currently. This may happen in rare circumstances, please check back in a few minutes."}}')
  delete Component.options._Ctor
}
